var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-svgrepo-com",
    transform: "translate(0.261 0.261)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_13267",
    "data-name": "Rect\\xE1ngulo 13267",
    width: 28,
    height: 28,
    transform: "translate(-0.261 -0.261)",
    fill: "rgba(255,255,255,0.01)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9017",
    "data-name": "Trazado 9017",
    d: "M18,31.545V19.454a3.454,3.454,0,0,1,6.909,0v12.09",
    transform: "translate(-7.715 -6.867)",
    fill: "none",
    stroke: "#a6192e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9018",
    "data-name": "Trazado 9018",
    d: "M12,27.272V16.909a6.909,6.909,0,0,1,13.817,0V27.272",
    transform: "translate(-5.169 -4.321)",
    fill: "none",
    stroke: "#a6192e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9019",
    "data-name": "Trazado 9019",
    d: "M6,21.848V14.363a10.363,10.363,0,0,1,20.726,0v7.484",
    transform: "translate(-2.624 -1.775)",
    fill: "none",
    stroke: "#a6192e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9020",
    "data-name": "Trazado 9020",
    d: "M24,38.484V31",
    transform: "translate(-10.261 -13.231)",
    fill: "none",
    stroke: "#a6192e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9021",
    "data-name": "Trazado 9021",
    d: "M24,23.458V21.875",
    transform: "translate(-10.261 -9.359)",
    fill: "none",
    stroke: "#a6192e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.46ddcd6d4c0e822b8ff24f8d8064e453.svg";
export { ForwardRef as ReactComponent };